import React, { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { isDesktop } from "react-device-detect";
import { default as ReactSelect } from "react-select";
import Swal from "sweetalert2";

import { formValidation, clearFormValidation } from "../../hoc/Shared/utility";
// import StringInput from "../../components/Input/StringInput/StringInput";
import NumberInput from "../../components/Input/NumberInput/NumberInput";
import Button from "../../components/Button/Button";
import SecurityPinModal from "../../components/SecurityPinModal/SecurityPinModal";
import moment from "moment";
import MobileQuotaDeposit from "./MobileQuotaDeposit";

import { getAgentProfile } from "../../store/ducks/profile/actions";
import * as actions from "../../store/ducks/delegateDeposit/actions";
import { checkSecurityPinAttempts } from "../../store/ducks/profile/actions";

class QuotaDeposit extends Component 
{
    constructor(props) 
    {
        super(props);
        const initLoad = this.props.delegateDepositShowInitialLoading.filter(item => item.id === "quota_deposit");
        const initialLoading = initLoad[0].loading;

        if (initialLoading) 
        {

            this.state = 
            {
                currentPage: "quota_deposit",
                authMethod: "auth_code",
                showQuota: false,
                
                memberId: "",
                // memberKey: "",
                amount: "",
                turnover: "",
                authCode: "",
                balance: 0.00,
                setting: {},
                downline: [],
                addSecurityPinStatus: false,

                showSelectRadio: false,
                mobileOpts: "",
                formError: false,
                errorMsg: [],
                openSecurityPinModal: false,
                converted_currency: "",
                converted_amount: "",

                transType: "withdrawal",
                reenter_security_pin_status: true,
                verify_payment_password_status: false,

                enter_pin_attempts: 3,
                time: {},
                seconds: 60,
                timer: 0,
                reenter_security_pin_status: true,
                verify_security_pin_status: true,
                security_pin_create_date: "",
            };

            this.props.setDelegateDepositLocalState(this.state);
        }
        else 
        {
            this.state = this.props.delegateDepositQuotaLocalState;
        }

        this.onInputChangeHandler = this.onInputChangeHandler.bind(this);
    }

    componentDidMount() 
    {
        if (localStorage.getItem("accessToken")) 
        {
            this.props.getAgentProfile();
        }

        formValidation("form");
        const initLoad = this.props.delegateDepositShowInitialLoading.filter(item => item.id === "quota_deposit");
        const initialLoading = initLoad[0].loading;

        if(initialLoading) 
        {
            this.props.funcGetDropDown();
            this.props.setDelegateDepositInitialLoading(this.state.currentPage);
        }
    }

    componentWillUnmount() 
    {
        this.props.setDelegateDepositLocalState(this.state);
    }

    shouldComponentUpdate(nextProps, nextState) 
	{
		const { t } = this.props;
        if (nextProps.topProfileData !== undefined && nextProps.topProfileData !== this.props.topProfileData) 
        {
            if (nextProps.topProfileData.responseCode === 200) 
            {
                this.setState({
                    addSecurityPinStatus: nextProps.topProfileData.data.agentProfile[0].paymentPasswordStatus === 1 ? true : false,
                });
            }
        }

        if (nextProps.dropDown !== this.props.dropDown && nextProps.dropDown !== undefined) 
        {
            if (nextProps.dropDown.responseCode === 200 && nextProps.dropDown.msgType === "success") 
            {
                this.setState({
                    balance: nextProps.dropDown.data.balance,
                    setting: nextProps.dropDown.data.payment_gateway,
                    downline: nextProps.dropDown.data.downline,
                });
            }
        }

        if (nextProps.verify_security_pin_result !== this.props.verify_security_pin_result) 
        {
            if (nextProps.verify_security_pin_result.responseCode === 200) 
            {
                if (nextProps.verify_security_pin_result.data.verify_payment_password_status === true) 
                {
                    this.setState({
                        verify_payment_password_status: true,
                        openSecurityPinModal: false,
                    }, ()=> 
                    {
                        const syntheticEvent = { preventDefault: () => {} };
                        this.submitHandler(syntheticEvent, true);
                    });
                }
            }
            else 
            {
                Swal.fire({
                    iconHtml: !isDesktop ? '<img src="https://api.iconify.design/mdi:close.svg?color=%23ffffff">' : "",
                    // icon: nextProps.verify_security_pin_result.msgType,
                    icon: "error",
                    title: t("global.error"),
                    html: nextProps.verify_security_pin_result.message[0],
                    showConfirmButton: true,
                    confirmButtonText: t("global.ok"),
                    customClass: !isDesktop
                        ? {
                            container: "swal-mobile-container failed",
                            icon: "swal-failed-icon",
                        }
                        : [],
                }).then(() => {
                    if (this.state.enter_pin_attempts !== 0) {
                        this.setState({
                            touched: true,
                            errorMsg: nextProps.verify_security_pin_result.message.input_error || [],
                            formError: true,
                            enter_pin_attempts: this.state.enter_pin_attempts - 1,
                            verify_security_pin_status: false,
                        });
                    }

                    if (this.state.enter_pin_attempts === 0) {
                        if (this.state.seconds === 0) {
                            // var now = moment(new Date()); //todays date
                            // var end = moment(this.state.security_pin_create_date); // another date
                            // var duration = moment.duration(now.diff(end));
                            // var seconds = duration.asSeconds();

                            this.setState({
                                timer: 0,
                                seconds: 60,
                            });
                        }

                        let timeLeftVar = this.secondsToTime(this.state.seconds);
                        // console.log(this.state.seconds);
                        // console.log(timeLeftVar);

                        // this.setState({ time: timeLeftVar });

                        this.startTimer();

                        this.setState({
                            time: timeLeftVar,
                            reenter_security_pin_status: false,
                            verify_security_pin_status: true,
                        });
                    }

                    Swal.close();
                });
            }
        }

        if (nextProps.check_security_pin_attempts_result !== this.props.check_security_pin_attempts_result) {
            if (nextProps.check_security_pin_attempts_result.responseCode === 200) {
                if (nextProps.check_security_pin_attempts_result.data) {
                    this.setState({
                        enter_pin_attempts:
                            nextProps.check_security_pin_attempts_result.data.security_pin_attempts !== 0
                                ? nextProps.check_security_pin_attempts_result.data.security_pin_attempts
                                : this.state.enter_pin_attempts,
                        security_pin_create_date: nextProps.check_security_pin_attempts_result.data
                            ? nextProps.check_security_pin_attempts_result.data.created_at
                            : this.state.security_pin_create_date,
                        checkSecurityAttemptsLoading: false,
                    });
                } else {
                    this.setState({
                        enter_pin_attempts: nextProps.check_security_pin_attempts_result.data
                            ? nextProps.check_security_pin_attempts_result.data.security_pin_attempts
                            : this.state.enter_pin_attempts,
                        security_pin_create_date: nextProps.check_security_pin_attempts_result.data
                            ? nextProps.check_security_pin_attempts_result.data.created_at
                            : this.state.security_pin_create_date,
                        checkSecurityAttemptsLoading: false,
                    });
                }

                const current = moment(new Date(), "YYYY-mm-dd HH:mm:ss");

                if (nextProps.check_security_pin_attempts_result.data) {
                    if (nextProps.check_security_pin_attempts_result.data.security_pin_attempts === 0) {
                        var t2 = moment(nextProps.check_security_pin_attempts_result.data.created_at);
                        var given = moment(t2, "YYYY-mm-dd HH:mm:ss");
                        const secondsLeft = moment.duration(current.diff(given)).asSeconds();

                        let minusSeconds = 60 - secondsLeft;
                        clearInterval(this.timer);

                        if (secondsLeft >= 60) {
                            this.setState({
                                reenter_security_pin_status: true,
                                verify_security_pin_status: true,
                            });
                        } else if (minusSeconds > 0) {
                            let timeLeftVar = this.secondsToTime(secondsLeft);

                            this.setState({
                                time: timeLeftVar,
                                seconds: minusSeconds,
                                reenter_security_pin_status: false,
                                verify_security_pin_status: true,
                            });

                            this.startTimer();
                        }
                    }
                }
            }
        }

		if (nextProps.store !== this.props.store && nextProps.store !== undefined) 
        {
            if (nextProps.store.responseCode === 200 && nextProps.store.msgType === 'success') 
            {
                Swal.fire({
                    iconHtml: !isDesktop ? '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">' : "",
                    icon: "success",
                    title: t("global.success"),
                    text: t("delegate-deposit.transfer-added"),
                    showConfirmButton: true,
                    confirmButtonText: t("global.ok"),
                    // timer: 2000,
                    customClass: !isDesktop
                        ? {
                              container: "swal-mobile-container sucess",
                              icon: "swal-success-icon",
                          }
                        : [],
                }).then(() => 
                {
                    clearFormValidation("form");
                    this.setState({
                        member: "",
                        amount: "",
                        turnover: "",
                        errorMsg: [],
                        formError: false,
                        converted_currency: "",
                        converted_amount: "",
                        verify_payment_password_status: false,
                        enter_pin_attempts: 3,
                    }, ()=>
                    {
                        this.props.redirectHandler('deposit_history');
                    });
                });
            }
            else 
            {
                clearFormValidation("form");
                if (nextProps.store.message.input_error) 
                {
                    this.setState({
                        errorMsg: nextProps.store.message.input_error || [],
                        formError: true,
                        verify_payment_password_status: false,
                    });
                    Swal.close();
                }
                else 
                {
                    let msg = null;
                    msg = "<div>";
                    nextProps.store.message.forEach((val) => {
                        msg += "<p>" + val + "</p>";
                    });
                    msg += "</div>";

                    Swal.fire({
                        iconHtml: !isDesktop ? '<img src="https://api.iconify.design/fa6-solid:face-sad-tear.svg?color=%23b0b0b0">' : "",
                        icon: "error",
                        title: t("global.sorry"),
                        html: msg,
                        showConfirmButton: true,
                        confirmButtonText: t("global.ok"),
                        customClass: !isDesktop
                            ? {
                                  container: "swal-mobile-container sorry",
                                  icon: "swal-sorry-icon",
                              }
                            : [],
                    }).then((result) => 
                    {
                        // if (result.isConfirmed) 
                        // {
                        //     if (nextProps.store.redirect && nextProps.store.redirect !== "" && nextProps.store.redirect !== null) {
                        //         window.location.href = nextProps.store.redirect;
                        //     }
                        // }
                    });
                }
            }
        }

        if(nextProps.currency_exchange !== undefined && nextProps.currency_exchange !== this.props.currency_exchange){
            if(nextProps.currency_exchange.responseCode === 200 && nextProps.currency_exchange.msgType === 'success'){
                this.setState({
                    converted_currency: nextProps.currency_exchange.data.currency,
                    converted_amount: nextProps.currency_exchange.data.amount,
                });
            }
        }

        return true;
	}

    getFilterArray = () => 
    {
        const listingArr = {};
        listingArr.page = this.state.activePage;
        listingArr.limit = this.state.limit;
        listingArr.order = JSON.stringify(this.state.order);
        listingArr.start_date = this.state.start_date;
        listingArr.end_date = this.state.end_date;
        listingArr.member = this.state.memberId;
        return listingArr;
    }

    onInputChangeHandler = (event) => 
	{
        // console.log(event.target.name+' | '+event.target.value)
		if (event.target.name === 'showQuota') 
        {
            this.setState({
                showQuota: !this.state.showQuota,
                errorMsg: [],
                formError: false,
                converted_currency: "",
                converted_amount: "",
            });
        }
        else 
        {
            this.setState({
                [event.target.name]: event.target.value,
                errorMsg: [],
                formError: false,
                converted_currency: "",
                converted_amount: ""
            });
        }

        if(event.target.name === 'amount'){
            if(this.state.memberId !== null && this.state.memberId !== "" && this.state.memberId !== undefined && event.target.value > 0){
                let data = {};
                data.member_id = this.state.memberId;
                data.amount = event.target.value;
                this.props.getCurrencyExchange(data);
            }
        }
	}

    memberChangeHandler = (event) => 
    {
		this.setState({
			memberId: event.id,
            mobileOpts: event !== null && event.id > 0 ? event : "",
            converted_currency: "",
            converted_amount: "",
		});
        if(event.id !== null && event.id !== "" && event.id !== undefined && this.state.amount > 0){
            let data = {};
            data.member_id = event.id;
            data.amount = this.state.amount;
            this.props.getCurrencyExchange(data);
        }
	}

    secondsToTime(secs) {
        let hours = Math.floor(secs / (60 * 60));

        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);

        let obj = {
            h: hours,
            m: minutes,
            s: seconds.toString().padStart(2, "0"),
        };
        return obj;
    }

    startTimer() {
        if (this.state.timer === 0 && this.state.seconds > 0) {
            this.timer = setInterval(this.countDown, 1000);
        }
    }

    countDown = () => {
        // Remove one second, set state so a re-render happens.
        let seconds = this.state.seconds - 1;

        this.setState({
            time: this.secondsToTime(seconds),
            seconds: seconds,
        });

        // Check if we're at zero.
        if (seconds === 0 || seconds <= 0) {
            clearInterval(this.timer);
            this.setState({ reenter_security_pin_status: true, seconds: 60, time: 0, enter_pin_attempts: 3 });
        }
    }

    // checkSecurityPinHandler = (e) => 
	// {
    //     e.preventDefault();
    //     this.props.funcStore(formData);
    // }

    // securityPinModalHandler = (value) => 
    // {
        // if (this.state.input.amount && this.state.input.bank_id && this.state.input.member_bank_account_id !== null && this.state.input.bank_acc_number) 
        // {
            // this.setState({ openSecurityPinModal: true, securityPinModal: value, checkSecurityAttemptsLoading: false });
        // }

        // this.props.checkSecurityPinAttempts();
    // }

    submitHandler = (e) => 
	{
		e.preventDefault();
		const { t } = this.props;
        
        if(this.state.addSecurityPinStatus)
        {
            if(!this.state.verify_payment_password_status)
            {
                this.setState({ 
                    openSecurityPinModal: true, 
                    securityPinModal: 'enter-sec-pin', 
                    checkSecurityAttemptsLoading: false,
                }, () => 
                {
                    this.props.checkSecurityPinAttempts();
                });
                return null;
            }
        }
        
        // console.log('here!');

        let html = t('delegate-deposit.confirmation-text', {from_currency: this.props.currentUser.currency, from_amount: this.state.amount, to_currency: this.state.converted_currency, to_amount: this.state.converted_amount});
        Swal.fire({
            iconHtml: (!isDesktop) ? '<img src="https://api.iconify.design/mdi:exclamation.svg?color=%23ffffff">' : '',
            title: t("global.confirmation"),
            // text: t("global.would-you-like-to-proceed") + "?",
            html: html,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: t("global.save"),
            cancelButtonText: t("global.cancel"),
            customClass: !isDesktop
                    ? {
                            container: "swal-mobile-container confirmation",
                            icon: "swal-confirmation-icon",
                        }
                    : [],
        }).then((result) => 
        {
            if (result.isConfirmed) 
            {
                Swal.fire({
                    title: "",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    didOpen: () => 
                    {
                        Swal.showLoading();
                    },
                });

                let formData = new FormData();
                formData.append('member_id', this.state.memberId);
                formData.append('amount', this.state.amount);
                formData.append('min_transfer', this.state.setting.transaction_minimum_payment_amount);
                formData.append('max_transfer', this.state.setting.transaction_maximum_payment_amount);
                formData.append('converted_amount', this.state.converted_amount);
                // for (var pair of formData.entries()) 
                // {
                //     console.log(pair[0]+ ' = ' + pair[1]);
                // }
                this.props.funcStore(formData);
            }
            else
            {
                this.setState({ 
                    verify_payment_password_status: false,
                });
            }
        });
	}

    imageImport = (r) => 
    {
        let images = {};
        r.keys().map((item, index) => 
        {
            return (images[item.replace("./", "")] = r(item)["default"]);
        });
        return images;
    }

    toggleSecurityPinModal = () => 
    {
        this.setState({
            openSecurityPinModal: !this.state.openSecurityPinModal
        })
    }

    render() 
    {
        // console.log(this.props.currentUser.currency);
        const { t } = this.props;
        const icons = this.imageImport(require.context("../../assets/images/icons", false, /\.(png|jpe?g|svg)$/));
        const img = this.imageImport(require.context("../../assets/images/loginregister/", false, /\.(png|jpe?g|svg|webp)$/));
        const num_format = { maximumFractionDigits: 2, minimumFractionDigits: 2 };
        let downlineList = [];
        
        if (this.state.downline) 
        {
            this.state.downline.map((val, idx) => 
            {
                return downlineList.push({
                    id: val.id,
                    label: val.username,
                    key: idx,
                });
            });
        }

        return (
        <>
            {isDesktop ? (
                <>
                <SecurityPinModal {...this.state} {...this.props} toggleSecurityPinModal={this.toggleSecurityPinModal}/>
                <div
                    className="tab-pane fade show active"
                    id="quota-deposit"
                    role="tabpanel"
                    aria-labelledby="quota-deposit-tab"
                >
                    <div className="quota-deposit-container">
                        <div className="row mt-3">
                            <div className="col-6">
                                <div className="available-amount-content mb-4">
                                    <img src={icons["wallet-icon.svg"]} alt="wallet" />
                                    <div className="amount-body">
                                        <p className="mb-2">{t('delegate-deposit.available-quota')}</p>
                                        <div className="amount">
                                            <p>
                                                {this.state.showQuota 
                                                ? 
                                                new Intl.NumberFormat("en-US", num_format).format(this.state.balance) 
                                                : 
                                                    '*******'
                                                }
                                            </p>
                                            <img
                                                className="show-hide-btn"
                                                src={img[`${(!this.state.showQuota) ? 'close-' : ''}eye.png`]}
                                                alt="hide pwd"
                                                id="showQuota"
                                                name="showQuota"
                                                onClick={(event) => this.onInputChangeHandler(event)}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <form className="forms-col needs-validation" method="post" id="form" encType='multipart/form-data' onSubmit={this.submitHandler} noValidate>
                                    <div>
                                        <label>
                                            <span className="text-danger">*</span> {t('delegate-deposit.member')}
                                        </label>
                                            <ReactSelect
                                                id='member_id'
                                                name='member_id'
                                                classNamePrefix="react-select"
                                                className={` ${(this.state.errorMsg.member_id) ? 'is-invalid' : ''}`}
                                                placeholder={t('delegate-deposit.select-member')}
                                                options={downlineList}
                                                onChange={this.memberChangeHandler}
                                                value={(this.state.memberId !== '') ? downlineList[this.state.memberId] : ''}
                                            />
                                            <div className="invalid-feedback">{this.state.formError && this.state.errorMsg.member_id}</div>
                                    </div>
                                    <div>
                                        <label>
                                            <span className="text-danger">*</span> {t('delegate-deposit.amount')}
                                        </label>
                                        <div className="input-group right has-validation">
                                            <NumberInput
                                                id="amount"
                                                name="amount"
                                                // className="form-control"
                                                className={`form-control ${this.state.errorMsg.amount && "was-validated is-invalid"}`}
                                                aria-label="Amount"
                                                aria-describedby="depositAmtHelp"
                                                value={this.state.amount}
                                                placeholder={`${t("deposit.min-max-limit")} ${new Intl.NumberFormat("en-US", num_format).format(
                                                    (this.state.setting.transaction_minimum_payment_amount) ? this.state.setting.transaction_minimum_payment_amount : 0.0
                                                )}/${new Intl.NumberFormat("en-US", num_format).format(
                                                    (this.state.setting.transaction_maximum_payment_amount) ? this.state.setting.transaction_maximum_payment_amount : 0.0
                                                )}`}
                                                onChange={(event) => this.onInputChangeHandler(event)}
                                                required={true}
                                                min={(this.state.setting.transaction_minimum_payment_amount) ? this.state.setting.transaction_minimum_payment_amount : 0.0}
                                                max={(this.state.setting.transaction_maximum_payment_amount) ? this.state.setting.transaction_maximum_payment_amount : 0.0}
                                                step="any"
                                                onKeyPress={(evt) => (evt.key === "e" || evt.key === "-" || evt.key === "+") && evt.preventDefault()}
                                                minValueMessage={t("validation.amtMinValue", {
                                                    0: ((this.state.setting.transaction_minimum_payment_amount) ? this.state.setting.transaction_minimum_payment_amount : 0.0),
                                                })}
                                                maxValueMessage={t("validation.amtMaxValue", {
                                                    0: ((this.state.setting.transaction_maximum_payment_amount) ? this.state.setting.transaction_maximum_payment_amount : 0.0),
                                                })}
                                                requiredMessage={t("validation.required")}
                                                formError={this.state.formError}
                                                errorMsg={this.state.errorMsg.amount || ""}
                                            />
                                        </div>
                                        {/* <p style={{ fontSize: "0.75rem" }}>
                                            1.00 ≤ single deposit amount ≤ 50,000.00, daily limit 10,000,000.00
                                        </p> */}
                                    </div>
                                    {/* <div>
                                        <label>
                                            <span className="text-danger">*</span> Withdrawal Turnover Multiplication.
                                        </label>
                                        <div className="input-group right has-validation">
                                            <NumberInput
                                                id="turnover"
                                                name="turnover"
                                                className={`form-control`}
                                                placeholder={'turnover'}
                                                value={this.state.turnover}
                                                onChange={(event) => this.onInputChangeHandler(event)}
                                                // step="any"
                                                // readOnly={memberBankAccount[inputArr.bank_id] ? true : false}
                                                // required={this.props.withdrawalOption === "bank-transfer" ? true : false}
                                                // requiredMessage={t("validation.required")}
                                                // formError={this.state.formError}
                                                // errorMsg={this.state.errorMsg.bank_acc_number || ""}
                                            />
                                            <span className="input-group-text bg-white">Times</span>
                                        </div>
                                        <p style={{ fontSize: "0.75rem" }}>1≤ Withdrawal turnover multiple ≤8</p>
                                    </div> */}
                                    {/* <div className="d-flex flex-column">
                                        <label>Authentication Method</label>
                                        <div className="d-flex justify-content-between">
                                            <div className="form-check form-check-inline">
                                                <input
                                                    className="btn-check"
                                                    type="radio"
                                                    name="authMethod"
                                                    id="authentication_code"
                                                    value="auth_code"
                                                    // onChange={() => {}}
                                                    onChange={(event) => this.onInputChangeHandler(event)}
                                                    checked={this.state.authMethod === "auth_code" ? true : false}
                                                />
                                                <label className="btn form-check-label" htmlFor="authentication_code">
                                                    <p>Authentication Code</p>
                                                </label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input
                                                    className="btn-check"
                                                    type="radio"
                                                    name="authMethod"
                                                    id="payment_password"
                                                    value="payment_pass"
                                                    onChange={(event) => this.onInputChangeHandler(event)}
                                                    checked={this.state.authMethod === "payment_pass" ? true : false}
                                                />
                                                <label className="btn form-check-label" htmlFor="payment_password">
                                                    <p>Payment Password</p>
                                                </label>
                                            </div>
                                        </div>
                                    </div> */}
                                    {/* {this.state.addSecurityPinStatus === true ? (
                                        <button
                                            className="btn btn-gradient-blue w-50"
                                            type="button"
                                            onClick={() => this.securityPinModalHandler("enter-sec-pin")}
                                            id="securityPinSubmitBtn"
                                        >
                                            {t("global.confirm")}
                                        </button>
                                    ) : ( */}
                                        <Button
                                            typeButton={`submit`}
                                            classValue="btn btn-gradient-blue w-50"
                                            buttonName={t('global.submit')}
                                            clicked={null}
                                            disabled={(this.state.converted_currency !== '' && this.state.converted_amount !== '') ? false : true}
                                        />
                                    {/* )} */}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                </>
            ) : (
                <MobileQuotaDeposit 
                    {...this.state} 
                    onInputChangeHandler={this.onInputChangeHandler} 
                    submitHandler={this.submitHandler}
                    memberChangeHandler={this.memberChangeHandler}
                    toggleSecurityPinModal={this.toggleSecurityPinModal}
                    downlineList={downlineList}
                />
            )}
        </>
        );
    }
}

const mapStateToProps = (state) => 
{
	const { delegateDeposit } = state;
	return {
        topProfileData: state.profile.get_agent_profile,
        delegateDepositShowInitialLoading: delegateDeposit.delegate_deposit_initial_loading,
        delegateDepositQuotaLocalState: delegateDeposit.delegate_deposit_quota_local_state,
        store: state.delegateDeposit.store,
        dropDown: state.delegateDeposit.dropDown,
        currency_exchange: state.delegateDeposit.currency_exchange,

        currentUser: state.currentUser.data,
        verify_security_pin_result: state.profile.verify_security_pin_result,
        check_security_pin_attempts_result: state.profile.check_security_pin_attempts_result,
	};
};

const mapDispatchToProps = (dispatch) => 
{
	return {
        getAgentProfile: () => dispatch(getAgentProfile()),
        setDelegateDepositLocalState: (data) => dispatch(actions.setDelegateDepositLocalState(data)),
        setDelegateDepositInitialLoading: (data) => dispatch(actions.setDelegateDepositInitialLoading(data)),
        funcStore: (data) => dispatch(actions.store(data)),
        funcGetDropDown: (filter) => dispatch(actions.getDropDown(filter)),
        getCurrencyExchange: (data) => dispatch(actions.getCurrencyExchange(data)),

        checkSecurityPinAttempts: (data) => dispatch(checkSecurityPinAttempts(data)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(QuotaDeposit));